import { combineReducers } from 'redux';
import changeboarding from '@confluence-classic/confluence-changeboarding/src/reducers.js';

import { dashboard } from './views/dashboard.js';
import spaceHome from './views/spaceHome.js';
import viewPage from './views/viewPage.js';
import space from './views/space.js';

export default combineReducers({
	dashboard,
	spaceHome,
	viewPage,
	space,
	changeboarding,
});
